/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListSequencesQueryResponse,
  ListSequencesQueryParams,
  ListSequences400,
  ListSequences404,
} from '../types/ListSequences'

function getListSequencesUrl() {
  const res = { method: 'GET', url: `/api/v1/emailbison/sequences/` as const }
  return res
}

/**
 * @description Get sequence for a campaign.
 * Query params:
 * campaign_id: Required - ID of the campaign
 * Returns:
 * Sequence detail if exists, null otherwise
 * @summary Get the sequence for a campaign
 * {@link /api/v1/emailbison/sequences/}
 */
export async function listSequences(
  params: ListSequencesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListSequencesQueryResponse,
    ResponseErrorConfig<ListSequences400 | ListSequences404>,
    unknown
  >({
    method: 'GET',
    url: getListSequencesUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
